import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from "react-router-dom";
import { setCurrentViewId, handleSnackBar, setFocusElement, toggleRightDrawer, invokeGetService, invokePostService, setReRender, setTabOnFocus, setForcedFocus, updateAiAssistant } from "../../../store/global/actions.js";
import { setView, editView, interruptViewAction } from "../../../store/views/actions.js";
import { getDetailsFromUrl } from '../../../services/blueprint.js';
import ShadowDOMWrapper from "../../atoms/Wrappers/ShadowDOM.js";
import LoaderWithProgress from '../../atoms/loader/LoaderWithProgress.js';
import { Tooltip, Grid, Box } from "@material-ui/core";
import Button from '@material-ui/core/Button';
import { makeStyles } from "@material-ui/core/styles";
import { getRightDrawerStatus, getDashboardRefresh, getReRender, getElementOnFocus } from '../../../store/global/selectors';
import CloneViewAlert from '../alerts/views/CloneViewAlert';
import DeleteItemAlert from '../../molecules/alerts/views/DeleteItemAlert';
import { getViewInterruptAction, getViews } from "../../../store/views/selectors.js";
import { modifyViewsSchemaWithMappedFields, updateViewSchema, getWidgetSampleData, generateViewsSampleData } from '../../../utils/DashboardBuilder.js';
import { generateViewsCode } from '../../../services/entities/DashboardBuilder.js';
import shortUuid from 'short-uuid';
import AlertDialog from "../../atoms/alertDialog/AlertDialog.js";
import LlmRegenrateAlert from "../alerts/LlmRegenrateAlert.js";

const useStyles = makeStyles((theme) => ({
    iconContainer: {
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center"
    },
    iconBox: {
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        gap: theme.spacing(1.5),
        margin: 5
    },
    iconTooltip: {
        cursor: "pointer",
    },
    icon: {
        fontSize: 24,
        /* border: 1px solid black; */
        width: 22,
        height: 22,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 0,
        cursor: "pointer",
        color: "#000"
    },
    deleteIcon: {
        color: theme.palette.error.main,
    },
    refreshBtn: {
        borderRadius: '2px !important'
    }
}));

const svgIcons = {
    delete: `<svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m19.5 5.5l-.62 10.025c-.158 2.561-.237 3.842-.88 4.763a4 4 0 0 1-1.2 1.128c-.957.584-2.24.584-4.806.584c-2.57 0-3.855 0-4.814-.585a4 4 0 0 1-1.2-1.13c-.642-.922-.72-2.205-.874-4.77L4.5 5.5M3 5.5h18m-4.944 0l-.683-1.408c-.453-.936-.68-1.403-1.071-1.695a2 2 0 0 0-.275-.172C13.594 2 13.074 2 12.035 2c-1.066 0-1.599 0-2.04.234a2 2 0 0 0-.278.18c-.395.303-.616.788-1.058 1.757L8.053 5.5m1.447 11v-6m5 6v-6" color="currentColor"/></svg>`,
    configuration: `<svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 24 24"><g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" color="currentColor"><path d="M2.256 15.632c.034-.323.268-.583.736-1.104l1.031-1.153c.252-.32.431-.875.431-1.375s-.179-1.056-.43-1.375L2.991 9.472c-.468-.52-.702-.781-.736-1.104s.14-.627.49-1.234l.494-.857c.373-.648.56-.972.878-1.1c.317-.13.676-.028 1.395.176l1.22.343c.459.106.94.046 1.358-.169l.337-.194a2 2 0 0 0 .788-.968l.334-.997c.22-.66.33-.99.591-1.18C10.403 2 10.75 2 11.444 2h1.115c.694 0 1.042 0 1.303.189s.371.519.59 1.179l.335.997a2 2 0 0 0 .788.968l.337.194c.418.215.9.275 1.358.17l1.22-.344c.719-.204 1.078-.306 1.395-.177c.318.13.505.453.878 1.101l.493.857c.35.607.525.91.491 1.234s-.268.583-.736 1.104l-1.031 1.153c-.252.319-.431.875-.431 1.375s.179 1.056.43 1.375l1.032 1.153c.468.52.702.781.736 1.104s-.14.627-.49 1.234l-.494.857c-.373.648-.56.972-.878 1.1c-.317.13-.676.028-1.395-.176l-1.22-.343a2 2 0 0 0-1.359.169l-.336.194c-.36.23-.636.57-.788.968l-.334.997c-.22.66-.33.99-.591 1.18c-.261.188-.609.188-1.303.188h-1.115c-.694 0-1.041 0-1.303-.189c-.261-.189-.371-.518-.59-1.178"/><path d="M2.737 18.78c1.08-1.08 4.752-4.716 5.112-5.136c.381-.444.072-1.044.256-2.904c.089-.9.282-1.574.836-2.076c.66-.624 1.2-.624 3.06-.666c1.62.042 1.812-.138 1.98.282c.12.3-.24.48-.672.96c-.96.96-1.524 1.44-1.578 1.74c-.39 1.32 1.146 2.1 1.986 1.26c.318-.318 1.788-1.8 1.932-1.92c.108-.096.367-.092.492.06c.108.106.12.12.108.6c-.01.444-.006 1.082-.004 1.74c.001.852-.044 1.8-.404 2.28c-.72 1.08-1.92 1.14-3 1.188c-1.02.06-1.86-.048-2.124.144c-.216.108-1.356 1.308-2.736 2.688l-2.46 2.46c-2.04 1.62-4.284-.9-2.784-2.7"/></g></svg>`,
    clone: `<svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 24 24"><g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" color="currentColor"><path d="M16.964 8.982c-.003-2.95-.047-4.478-.906-5.524a4 4 0 0 0-.553-.554C14.4 2 12.76 2 9.48 2s-4.92 0-6.024.905a4 4 0 0 0-.553.554C1.998 4.56 1.998 6.2 1.998 9.48s0 4.92.906 6.023q.25.304.553.553c1.047.86 2.575.904 5.525.906"/><path d="m14.028 9.025l2.966-.043m-2.98 13.02l2.966-.043m4.992-7.937l-.028 2.96M9.01 14.036l-.028 2.96m2.505-7.971c-.832.149-2.17.302-2.477 2.024m10.485 10.91c.835-.137 2.174-.27 2.508-1.986M19.495 9.025c.832.149 2.17.302 2.477 2.024M11.5 21.957c-.833-.148-2.17-.301-2.478-2.023"/></g></svg>`,
    add: `<svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M12 8v8m4-4H8m14 0c0-5.523-4.477-10-10-10S2 6.477 2 12s4.477 10 10 10s10-4.477 10-10" color="currentColor"/></svg>`,
    edit: `<svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 24 24"><g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" color="currentColor"><path d="m16.214 4.982l1.402-1.401a1.982 1.982 0 0 1 2.803 2.803l-1.401 1.402m-2.804-2.804l-5.234 5.234c-1.045 1.046-1.568 1.568-1.924 2.205S8.342 14.561 8 16c1.438-.342 2.942-.7 3.579-1.056s1.16-.879 2.205-1.924l5.234-5.234m-2.804-2.804l2.804 2.804"/><path d="M21 12c0 4.243 0 6.364-1.318 7.682S16.242 21 12 21s-6.364 0-7.682-1.318S3 16.242 3 12s0-6.364 1.318-7.682S7.758 3 12 3"/></g></svg>`,
    not_default: `<svg width="17" height="20" viewBox="0 0 17 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.1406 0.130982L0.23418 6.79819C0.0882853 6.92224 -0.00121473 7.12623 1.246e-05 7.33298V19.3329C1.246e-05 19.6816 0.281996 20 0.593394 20H5.93025C6.24043 20 6.52364 19.683 6.52364 19.3329V12.0002H10.4764V19.3329C10.4764 19.6816 10.7584 20 11.0698 20H16.4066C16.7168 20 17 19.683 17 19.3329V7.33298C17 7.1276 16.9117 6.92222 16.7658 6.79819L8.85941 0.132393C8.60072 -0.0523053 8.37512 -0.0357634 8.14343 0.132393L8.1406 0.130982ZM8.49859 1.4983L15.8118 7.66516V18.6644H11.6604V11.3317C11.6604 10.983 11.3784 10.6646 11.067 10.6646H5.92758C5.6174 10.6646 5.3342 10.9816 5.3342 11.3317V18.6644H1.18279V7.66516L8.49859 1.4983Z" fill="black"/></svg>`,
    default: `<svg width="17" height="20" viewBox="0 0 17 20" xmlns="http://www.w3.org/2000/svg"><path d="M8.1406 0.130982L0.23418 6.79819C0.0882853 6.92224 -0.00121473 7.12623 1.246e-05 7.33298V19.3329C1.246e-05 19.6816 0.281996 20 0.593394 20H5.93025C6.24043 20 6.52364 19.683 6.52364 19.3329V12.0002H10.4764V19.3329C10.4764 19.6816 10.7584 20 11.0698 20H16.4066C16.7168 20 17 19.683 17 19.3329V7.33298C17 7.1276 16.9117 6.92222 16.7658 6.79819L8.85941 0.132393C8.60072 -0.0523053 8.37512 -0.0357634 8.14343 0.132393L8.1406 0.130982ZM8.49859 1.4983L15.8118 7.66516V18.6644H11.6604V11.3317C11.6604 10.983 11.3784 10.6646 11.067 10.6646H5.92758C5.6174 10.6646 5.3342 10.9816 5.3342 11.3317V18.6644H1.18279V7.66516L8.49859 1.4983Z" fill="#c34322"stroke="#c34322"stroke-width="1.2"/></svg>`,
    aiTool: `<svg width="100pt" height="100pt" version="1.1" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
        <path d="m68.688 53.613c1.5234-0.54297 2.543-1.9961 2.543-3.6133s-1.0234-3.0703-2.5391-3.6133l-6.9688-2.5117c-6.8828-2.4766-12.25-7.8516-14.73-14.73l-2.5117-6.9688c-0.54688-1.5156-1.9961-2.5391-3.6055-2.5391h-0.003906c-1.6133 0-3.0625 1.0195-3.6133 2.5391l-2.5078 6.9688c-2.4805 6.8828-7.8516 12.254-14.734 14.73l-6.9609 2.5117c-1.5234 0.54688-2.5469 1.9961-2.5469 3.6133s1.0234 3.0664 2.5391 3.6133l6.9688 2.5117c6.8828 2.4766 12.25 7.8477 14.73 14.73l2.5117 6.9727c0.54688 1.5156 2 2.5352 3.6133 2.5352h0.003906c1.6133 0 3.0625-1.0234 3.6055-2.5391l2.5117-6.9688c2.4766-6.8828 7.8516-12.25 14.73-14.73zm-9.082-3.3711c-8.6406 3.1133-15.383 9.8516-18.492 18.492l-0.24219 0.67578-0.24219-0.67578c-3.1172-8.6406-9.8555-15.383-18.492-18.492l-0.67578-0.24219 0.67578-0.24219c8.6406-3.1133 15.383-9.8516 18.492-18.492l0.24219-0.67578 0.24219 0.67578c3.1133 8.6406 9.8516 15.383 18.492 18.492l0.67578 0.24219z" fill="#2c3b4a"/>
        <path d="m57.961 23.32 3.5273 1.2734c3.0547 1.1016 5.4297 3.4805 6.5312 6.5312l1.2695 3.5234c0.49609 1.3828 1.8164 2.3086 3.2812 2.3086 1.4648 0 2.7891-0.92969 3.2812-2.3047l1.2734-3.5273c1.1016-3.0547 3.4805-5.4336 6.5312-6.5312l3.5312-1.2734c1.3711-0.49609 2.3008-1.8125 2.3047-3.2734 0.003906-1.4609-0.91406-2.7812-2.3047-3.2891l-3.5312-1.2656c-3.0508-1.1016-5.4297-3.4805-6.5312-6.5312l-1.2734-3.5273c-0.49609-1.3828-1.8125-2.3086-3.2773-2.3086-1.4688 0-2.7891 0.92969-3.2812 2.3047l-1.2734 3.5273c-1.1016 3.0547-3.4805 5.4297-6.5312 6.5312l-3.5391 1.2734c-1.375 0.5-2.3008 1.8203-2.2969 3.2852 0.007812 1.4648 0.93359 2.7812 2.3086 3.2734zm14.613-9.3984c1.4805 2.5391 3.5859 4.6406 6.1172 6.1172-2.5391 1.4805-4.6406 3.5859-6.1172 6.1172-1.4805-2.5352-3.5859-4.6406-6.1172-6.1172 2.5352-1.4805 4.6367-3.582 6.1172-6.1172z" fill="#2c3b4a"/>
        <path d="m87.184 76.68-3.5273-1.2734c-3.0508-1.1016-5.4297-3.4805-6.5312-6.5312l-1.2734-3.5273c-0.49609-1.3789-1.8164-2.3047-3.2812-2.3047-1.4688 0-2.7891 0.92969-3.2812 2.3047l-1.2734 3.5273c-1.1016 3.0547-3.4805 5.4336-6.5312 6.5312l-3.5234 1.2695c-1.3789 0.49219-2.3047 1.8125-2.3086 3.2734-0.003906 1.4609 0.91797 2.7852 2.3047 3.2891l3.5273 1.2734c3.0547 1.1016 5.4336 3.4766 6.5312 6.5312l1.2695 3.5234c0.50391 1.3789 1.8203 2.3086 3.2891 2.3086s2.7891-0.92969 3.2812-2.3047l1.2734-3.5273c1.1016-3.0508 3.4805-5.4297 6.5312-6.5312l3.543-1.2734c1.3711-0.50391 2.293-1.8203 2.2891-3.2852 0-1.4648-0.93359-2.7773-2.3086-3.2734zm-14.609 9.3984c-1.4805-2.5391-3.5859-4.6406-6.1172-6.1172 2.5352-1.4805 4.6406-3.5859 6.1172-6.1172 1.4805 2.5352 3.5859 4.6406 6.1172 6.1172-2.5312 1.4805-4.6367 3.582-6.1172 6.1172z" fill="#2c3b4a"/>
        </svg>`,
    aiEdit: `<svg width="50" height="50" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M40.1307 8.28666C44.0681 4.3544 50.4484 4.3544 54.3813 8.28666C58.3136 12.2189 58.3136 18.5992 54.3813 22.532L25.5373 51.3813C23.6051 53.3136 21.1936 54.6783 18.5477 55.3397L11.1363 57.1887C7.71959 58.0428 4.62586 54.9491 5.47999 51.5324L7.32892 44.1157C7.99038 41.4751 9.36012 39.0636 11.2873 37.1365L40.1307 8.28666ZM51.5525 11.1148C49.1828 8.74506 45.3337 8.74506 42.9588 11.1148L14.1148 39.9641C12.6981 41.3756 11.6981 43.1516 11.2137 45.0892L9.35959 52.5007C9.2398 52.9903 9.68251 53.433 10.1669 53.308L17.5783 51.4538C19.521 50.9694 21.292 49.9694 22.7086 48.5528L51.5526 19.7034C53.9223 17.3337 53.9223 13.4845 51.5525 11.1148Z" fill="black"/><path fill-rule="evenodd" clip-rule="evenodd" d="M12.6667 0C13.4844 0 14.2188 0.5 14.5208 1.25521L16.7083 6.72401C17.0572 7.5886 17.7447 8.27615 18.6093 8.62508L24.0781 10.8021C24.8334 11.1094 25.3334 11.8438 25.3334 12.6615C25.3334 13.4792 24.8386 14.2188 24.0781 14.5208L18.6093 16.7083C17.7448 17.0572 17.0572 17.7447 16.7083 18.6093L14.5208 24.0781C14.2187 24.8334 13.4844 25.3334 12.6667 25.3334C11.849 25.3334 11.1145 24.8334 10.8125 24.0781L8.62508 18.6093C8.27612 17.7448 7.58863 17.0572 6.72401 16.7083L1.25521 14.5208C0.4948 14.2187 0 13.4791 0 12.6615C0 11.8438 0.5 11.1093 1.25521 10.8021L6.72401 8.62508C7.5886 8.27612 8.27615 7.58863 8.62508 6.72401L10.8125 1.25521L10.9428 0.984388C11.2969 0.380228 11.9531 0 12.6667 0ZM12.3386 8.20307C11.5833 10.0885 10.0886 11.5833 8.20309 12.3385L7.38538 12.6615L8.2135 12.9948C10.0938 13.75 11.5832 15.2448 12.3386 17.1251L12.6667 17.9532L12.9948 17.1251C13.75 15.2448 15.2396 13.7501 17.1199 12.9948L17.9428 12.6615L17.1303 12.3385C15.2448 11.5833 13.75 10.0885 12.9948 8.20307L12.6667 7.38015L12.3386 8.20307Z" fill="black"/></svg>`
}

const SchemaBuilder = ({generateTransactionWithAI, isAIGeneratingTransaction, setMessageList}) => {
    const dispatch = useDispatch();
    const shadowRef = useRef(null);
    const classes = useStyles();
    const history = useHistory();

    const viewDetails = useSelector(getViews);
    const dashboardRefresh = useSelector(getDashboardRefresh);
    const reRender = useSelector(getReRender);
    const elementOnFocus = useSelector(getElementOnFocus);
    const isInterruptView = useSelector(getViewInterruptAction)

    const [loading, setLoading] = useState(false);
    const [styles, setStyles] = useState([]);
    const [action, setAction] = useState(null);
    const [isDefaultView, setDefaultView] = useState(false)
    const [dashboardInstance, setDashboardInstance] = useState(null);
    const [constructs, setConstructs] = useState({});
    const [assets, setAssets] = useState([]);
    const [errorMessage, setErrorMessage] = useState(null)
    const [showAIRegenerateIcon, setShowAIRegenerateIcon] = useState(false)
    const { blueprintId, entityId, slug } = getDetailsFromUrl();
    const [openRegenrationAlert, setOpenRegenerationAlert] = useState(false)


    useEffect(() => {
        loadSchemaBuilder();
    }, [entityId, reRender]);

    useEffect(() => {
        if (!action?.type) return;

        switch (action.type) {
            case "edit_section":
                dispatch(setFocusElement({ type: "section", id: action.id, name: action.name }));
                break;
            case "clone_section":
                onCopySection(action.id)
                break;
            case "clone_widget":
                onCopyWidget(action.id, action.parent)
                break;
            case "delete_widget":
                onDeleteWidget(action.id, action.parent)
                break;
            case "add_widget":
                dispatch(setFocusElement({ type: "ui", action: 'create', parentID: action.parent }));
                dispatch(setForcedFocus(true));
                dispatch(setTabOnFocus(0))
                break;
            case "edit_widget":
                dispatch(setFocusElement({ type: "ui", id: action.id, action: 'edit', name: action.name, widgetType: action.widgetType }));
                break;
            case "widget_change":
                onWidgetChange(action.data);
                break;
            default:
                break;
        }

    }, [action]);

    useEffect(() => {
        if (dashboardRefresh && dashboardInstance) {
            try {
            
                const { type, action, entity } = dashboardRefresh;
                
                if (type && action && entity) {
                    if (type === "section") {
                        if (action === "create") {
                            dashboardInstance.addSection(entity, {});
                        } else if (action === "edit") {
                            // dashboardInstance.removeSection(entity.id);
                            const schemaData = generateViewsSampleData({ viewsSchema: [entity], assets, blueprintId, slug, clusterlets: constructs.clusterlets });
                            const updatedView = viewDetails.view_schema?.map(item => {
                                if (entity.id === item.id) {
                                    return entity
                                } else {
                                    return item
                                }
                            })
                            dashboardInstance.refreshSection(entity, schemaData, updatedView);
                        }
                    } else if (type === "widget") {
                        console.log("--widget--", {action})
                        const sampleData = getWidgetSampleData({ widget: entity, assets, blueprintId, slug, clusterlets: constructs.clusterlets });
                        if (action === "create") {
                            let updatedSchema = dashboardInstance.addWidget(entity, dashboardRefresh?.parent, sampleData);
                            const updatedView = {
                                ...viewDetails,
                                view_schema: updatedSchema
                            }
                            handleViewUpdate(updatedView, "Widget", "create");
                            const updatedEntity = handleSchemaIcons([{ children: [entity] }]);
                            dashboardInstance.refreshWidget(updatedEntity[0]?.children[0], sampleData)

                        } else if (action === "edit") {
                            const updatedEntity = handleSchemaIcons([{ children: [entity] }]);
                            dashboardInstance.refreshWidget(updatedEntity[0]?.children[0], sampleData)
                        }
                    }
                }


            } catch (error) {
                console.error("Handling dashboard changes failed. ", error);
                return null;
            }
        }
    }, [dashboardRefresh])

    useEffect(() => {
        if(!isAIGeneratingTransaction && viewDetails) {
            const isMapped = isViewTransactionMapped();
            setShowAIRegenerateIcon(isMapped);
        }
    }, [isAIGeneratingTransaction, viewDetails]);



    const loadSchemaBuilder = async () => {
        try {
            setLoading(true);

            const { status, data, message } = await dispatch(invokeGetService('getDashboardBuilder', [entityId]))

            if (status === false) {
                setLoading(false);
                dispatch(handleSnackBar({ open: true, message: message, severity: 'error' }))
                return;
            }
            const { view, styles, clusterlets, transactions, events, messages, sections, fields, assets } = data;
            setStyles(styles);
            let modifiedSchema = modifyViewsSchemaWithMappedFields({ schema: view?.view_schema, clusterlets, transactions, events, messages, sections, fields });
            modifiedSchema = handleSchemaIcons(modifiedSchema);
            view.view_schema = modifiedSchema;
            dispatch(setView(view));
            setAssets(assets);
            setMessageList(messages);
            setConstructs({ clusterlets, transactions, events, messages, sections, fields })
            dispatch(setCurrentViewId(view._id));
            setDefaultView(view?.default || false)

            try{
                await waitForRenderDashboard(20)
            }catch(error){
                setErrorMessage(error.message)
                setLoading(false)
                return false
            }

            setLoading(false);
            renderDashboardBuilder({ views: view, clusterlets, transactions, events, messages, sections, fields, assets });
        } catch (error) {
            console.error("Error when fetching dashboard builder:", error);
            dispatch(handleSnackBar({ open: true, message: error.message ? error.message : "Something went wrong", severity: 'error' }))
        }
    };

    const waitForRenderDashboard = async (maxRetries = 10, interval = 300) => {
        let retries = 0;
      
        return new Promise((resolve, reject) => {
          const check = () => {
            if (window.RenderDashboard) {
              resolve(window.RenderDashboard);
            } else if (retries >= maxRetries) {
              reject(new Error("Something went wrong while rendering. Please refresh the screen"));
            } else {
              retries++;
              setTimeout(check, interval);
            }
          };
      
          check();
        });
    };

    const handleSchemaIcons = (schema) => {
        try {
        
        schema.forEach(section => {
            section?.children?.forEach(widget => {
                if (widget.type === "counter" && widget.customicon) {
                    const assetUrl = window.location.origin;

                    if (widget?.iconSource === 'custom' || widget?.isCustomIcon) {
                        const assetDirectoryName = `${blueprintId}_${slug}`;
                        widget.iconsrc = `${assetUrl}/blueprintAssets/${assetDirectoryName}/${widget.customicon}`;
                    } else if (widget?.iconSource === 'library') {
                        widget.iconsrc = `${assetUrl}/cached_icons/${widget.customicon}`;
                    } else {
                        widget.iconsrc = `${assetUrl}/node_icons/${widget.customicon}.svg`;
                    }
                }
            })
        })

        return schema;

        } catch (error) {
            console.error(`Handling schema icons failed. `,error);
            return schema;
        }
    }

    const waitForGlobal = (name, timeout = 5000) => {
        return new Promise((resolve, reject) => {
            const start = Date.now();
            (function check() {
                if (window[name]) return resolve(window[name]);
                if (Date.now() - start > timeout) return reject(`${name} not found in time`);
                requestAnimationFrame(check);
            })();
        });
    }


    const renderDashboardBuilder = async ({ views, clusterlets, transactions, events, messages, sections, fields, assets }) => {
        try {
            const schema = JSON.parse(JSON.stringify(views.view_schema));

            window.isAppview = true;
            window.g_view_data = [{ rid: 4551, sslice: "application", version: 15201, appid: "bp", clusterid: "com.example.local" }];
            if (shadowRef.current) {

                await Promise.all([   // wait untill dependencies are loaded
                    waitForGlobal('RenderDashboard'),
                    waitForGlobal('GridStack'),
                ]);

                let dashboard = new window.RenderDashboard(shadowRef.current, {}, true, true, {
                    triggerAction: setAction
                });
                setDashboardInstance(dashboard);
                const schemaData = generateViewsSampleData({ viewsSchema: schema, assets, blueprintId, slug, clusterlets, code: views.code });
                dashboard.render_schema(schema);
                dashboard.render_data(schemaData);
            } else {
                console.error("Element with ID 'dashboard_builder' not found inside Shadow DOM")
            }
        } catch (error) {
            console.error("Error when rendering dashboard builder:", error);
        }
    }

    const onRegenerateDataSource = () => {
        // generateTransactionWithAI();
        setOpenRegenerationAlert(true)
    }

    const isViewTransactionMapped = () => {
        if (!viewDetails) return false;
      
        const hasMapping = (obj) =>
          obj?.mapping &&
          typeof obj.mapping === "object" &&
          Object.keys(obj.mapping).length > 0;
      
        if (hasMapping(viewDetails)) return true;
      
        return viewDetails.view_schema?.some(section =>
          hasMapping(section) ||
          section.children?.some(widget => hasMapping(widget))
        );
      };
      


    const onAddSection = () => {
        dispatch(setFocusElement({ type: "section" }));
    }

    const onEditView = () => {
        dispatch(setFocusElement({ type: "view", id: entityId }));
    }

    const onCloneView = () => {
        setAction({ type: "clone_view" });
    }

    const onDeleteView = () => {
        setAction({ type: "delete_view" });
    }

    const onWidgetChange = (updatedSchema) => {
        const updatedView = {
            ...viewDetails,
            view_schema: updatedSchema
        }
        handleViewUpdate(updatedView);
    }
    


    const updateChildrenWithNewIDs = (schemas = []) => {
        try {
          return schemas.map(item => {
            // regenerate id if present
            const updatedItem = {
              ...item,
              ...(item?.id && { id: shortUuid.generate() }),
            };
      
            // recursively update children
            if (Array.isArray(item?.children) && item.children.length > 0) {
              updatedItem.children = updateChildrenWithNewIDs(item.children);
            }
      
            return updatedItem;
          });
        } catch (error) {
          console.error(` Regenerating IDs failed: ${error}`);
          return schemas;
        }
      };

    const onCopySection = (sectionId) => {
        let copiedSection = viewDetails?.view_schema?.find(section => section.id === sectionId);
        copiedSection = JSON.parse(JSON.stringify(copiedSection));
        if (copiedSection) {
            const newSection = {
                ...copiedSection,
                id: shortUuid.generate(),
                name: getCopiedFieldName(viewDetails?.view_schema, copiedSection.name) || `${copiedSection?.name}_copy`,
                children: updateChildrenWithNewIDs(copiedSection.children)
            }

            delete newSection.positions;
            const view_schema = dashboardInstance.schema ? dashboardInstance.schema : [...viewDetails?.view_schema, newSection];
            const updatedView = {
                ...(viewDetails || {}),
                view_schema: view_schema
            }
            const sectionData = generateViewsSampleData({ viewsSchema: [newSection], assets, blueprintId, slug, clusterlets: constructs.clusterlets });

            dashboardInstance.addSection(newSection, sectionData);
            handleViewUpdate(updatedView);
        }
    }

    const getCopiedFieldName = (entities, copiedEntityName, index = 0) => {
        try {
            const newEntityName = `${copiedEntityName}_copy${(index && index !== 0) ? index : ''}`;
            for (let i = 0; i < entities?.length; i++) {
                if (entities[i]?.name === newEntityName) {
                    return getCopiedFieldName(entities, copiedEntityName, index + 1)
                }
            }
            return newEntityName;
        } catch (error) {
            console.error(`Generating cloned field name failed. ${error}`);
            return copiedEntityName;
        }
    }

    const onCopyWidget = (widgetId, sectionId) => {
        const parentSection = viewDetails?.view_schema?.find(section => section.id === sectionId);
        if (parentSection && parentSection.children) {
            const copiedWidget = parentSection.children.find(widget => widget.id === widgetId);
            if (copiedWidget) {
                const newWidget = {
                    ...copiedWidget,
                    id: shortUuid.generate(),
                    name: getCopiedFieldName(parentSection.children, copiedWidget.name) || `${copiedWidget?.name}_copy`,
                    children: updateChildrenWithNewIDs(copiedWidget.children)
                }
                delete newWidget.positions;
                const sampleData = getWidgetSampleData({ widget: newWidget, assets, blueprintId, slug, clusterlets: constructs.clusterlets });
                const updatedView = updateViewSchema(viewDetails, 'add', { parentId: sectionId, newItem: newWidget });
                dashboardInstance.addWidget(newWidget, sectionId, sampleData);
                const viewCode = generateViewsSampleData({ viewsSchema: updatedView.view_schema, assets, blueprintId, slug, clusterlets: constructs.clusterlets, code: updatedView.code, widgetId, widgetData: sampleData });
                updatedView.code = generateViewsCode(viewCode);
                handleViewUpdate(updatedView);
            }
        }
    }

    const onDeleteWidget = (widgetId, sectionId) => {
        const updatedView = updateViewSchema(viewDetails, 'delete', { id: widgetId });
        dashboardInstance.removeWidget(widgetId, sectionId);
        handleViewUpdate(updatedView);

        if (elementOnFocus?.id === widgetId) dispatch(setFocusElement({}));
    }



    const handleViewUpdate = (updatedView, entitiy=null, action=null ) => {
        dispatch(invokePostService('updateView', { view: updatedView }, [entityId])).then(response => {
            if (response.status === true) {
                if(action && entitiy){
                    dispatch(handleSnackBar({ open: true, message: `${entitiy} ${action === "create" ? "created" : "delete" ? "deleted" : "updated"}`, severity: 'success' }));
                }

                dispatch(editView(updatedView));
            } else {
                if (response.code === 255) {
                    history.push(`/blueprint/${slug}/${blueprintId}/system-model`);
                    dispatch(setReRender());
                    dispatch(setFocusElement({}));
                }
            }
        })
    }

    const onDefaultViewClick = () => {
        if(isDefaultView === false) localStorage.setItem('DISABLE_DEFAULTVIEW_ALERT', 'true');
        dispatch(invokePostService('viewUpdateDefault', { default: !isDefaultView }, [viewDetails?._id])).then(response => {
            if (response.status === true) {
                setDefaultView(prev => !prev)
            } else {

            }
        });
    }

    function reload() {
        window.location.reload();
      }
    return (
        <>
            <AlertDialog 
                open={isInterruptView} 
                title="Something went wrong" 
                content="Something went wrong while saving your changes. Please refresh the page to continue" 
                proceedText="Refresh" 
                hideAbort
                onProceed={() => reload()}
            />
            {!loading &&
                <Grid container className={classes.iconContainer}>
                    <Box className={classes.iconBox}>
                       { showAIRegenerateIcon && <Tooltip title={isAIGeneratingTransaction ? "Regenerating..." : "Regenerate data source"} className={classes.iconTooltip}>
                            <span
                                id="ai-regenerate-datasource"
                                className={classes.icon}
                                color="primary"
                                data-ui-tour-id="btn-ai-regenerate-datasource"
                                onClick={onRegenerateDataSource}
                                dangerouslySetInnerHTML={{ __html: svgIcons["aiTool"] }}
                                style={{
                                    pointerEvents: isAIGeneratingTransaction ? "none" : "auto",
                                    opacity: isAIGeneratingTransaction ? 0.5 : 1,
                                    cursor: isAIGeneratingTransaction ? "not-allowed" : "pointer"
                                }}
                            />
                        </Tooltip>}

                        <Tooltip title="Add section" className={classes.iconTooltip}>
                            <span
                                id="add_section"
                                className={classes.icon}
                                color="primary"
                                data-ui-tour-id="btn-add-section-view"
                                onClick={onAddSection}
                                dangerouslySetInnerHTML={{ __html: svgIcons["add"] }}
                            />
                        </Tooltip>

                        <Tooltip title="Edit view" className={classes.iconTooltip}>
                            <span
                                id="edit_view"
                                className={classes.icon}
                                color="primary"
                                data-ui-tour-id="btn-edit-view"
                                onClick={onEditView}
                                dangerouslySetInnerHTML={{ __html: svgIcons["edit"] }}
                            />
                        </Tooltip>

                        <Tooltip title="Clone view" className={classes.iconTooltip}>
                            <span
                                id="clone_view"
                                className={classes.icon}
                                color="primary"
                                data-ui-tour-id="btn-clone-view"
                                onClick={onCloneView}
                                dangerouslySetInnerHTML={{ __html: svgIcons["clone"] }}
                            />
                        </Tooltip>

                        {
                            isDefaultView ?
                                <Tooltip title="Mark view as not default" className={classes.iconTooltip}>
                                    <span
                                        id="not_default_view"
                                        className={classes.icon}
                                        color="primary"
                                        data-ui-tour-id="btn-default"
                                        onClick={onDefaultViewClick}
                                        dangerouslySetInnerHTML={{ __html: svgIcons["default"] }}
                                    />
                                </Tooltip>
                                :
                                <Tooltip title="Mark view as default" className={classes.iconTooltip}>
                                    <span
                                        id="default_view"
                                        className={classes.icon}
                                        color="primary"
                                        data-ui-tour-id="btn-default"
                                        onClick={onDefaultViewClick}
                                        dangerouslySetInnerHTML={{ __html: svgIcons["not_default"] }}
                                    />
                                </Tooltip>
                        }

                        <Tooltip title="Delete view" className={classes.iconTooltip}>
                            <span
                                id="delete_view"
                                className={classes.icon}
                                color="primary"
                                data-ui-tour-id="btn-delete-view"
                                onClick={onDeleteView}
                                dangerouslySetInnerHTML={{ __html: svgIcons["delete"] }}
                            />
                        </Tooltip>
                    </Box>
                </Grid>}
            {/* {loading && <LoaderWithProgress size={20} isContent={true} styleRoot={{ marginTop: 'calc((100vh - 64px)/2)' }} />} */}
            <ShadowDOMWrapper id="dashboard_builder_parent">
                <link rel="stylesheet" href="/viewpreview/css/gridstack-extra.min.css"></link>
                <link rel="stylesheet" href="/viewpreview/css/gridstack.min.css"></link>

                {styles.map((style, index) => (
                    <link key={index} rel="stylesheet" href={`/viewpreview/css/${style}`} />
                ))}

                {loading && <LoaderWithProgress size={20} isContent={true} styleRoot={{ marginTop: 'calc((100vh - 64px)/2)' }} />}

                {
                    errorMessage &&
                    <div style={{width: '100%', height: 'calc(100vh - 25vh)', display: 'flex', justifyContent: "center", flexDirection: "column", alignItems: "center"}}>
                        <h5>{errorMessage}</h5>
                        <Button style={{background: "rgb(223 223 223)", color: "black", padding:"0.5rem", border: "none"}} className={classes.refreshBtn} color="primary" variant="contained" onClick={() => window.location.reload()}>Refresh</Button>
                    </div>
                }

                {!loading &&
                    <div
                        ref={shadowRef}
                        id="dashboard_builder"
                    >

                    </div>
                }

            </ShadowDOMWrapper>

            {action?.type === "clone_view" &&
                <CloneViewAlert onClose={e => setAction(null)} />
            }

            {(action?.type === "delete_view" || action?.type === "delete_section") &&
                <DeleteItemAlert dashboardInstance={dashboardInstance} type={action.type.split('_')[1]} id={action.id} onClose={e => setAction(null)} />

            }

            {openRegenrationAlert &&  <LlmRegenrateAlert onClose={()=> setOpenRegenerationAlert(false)} onProceed={generateTransactionWithAI}/>}
        </>
    );
};


export default SchemaBuilder;